<template>
    <div id="app">
        <div class="mobile" v-if="isMobile && isChromeOrSafari">
            <div class="sticky-top" id="headers"></div>
            <!--error-boundary-->
                <router-view></router-view>
            <!--/error-boundary-->

            <portal-target name="mobile-root"></portal-target>
        </div>
        <div v-else>
            <div class="marginLogo">
                <img
                    src="./assets/inovaclickPngs/vexImagem.png"
                    height="160"
                    width="160"
                />
            </div>
            <div class="marginTitle">
                <div class="title">Vistoria não permitida</div>
                <div class="subtitle">
                    Foi detectado acesso por Desktop ou navegador não homologado.
                </div>
            </div>
            <div class="margin">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="140"
                    height="140"
                    fill="currentColor"
                    class="mt-4 bi bi-phone"
                    viewBox="0 0 16 16"
                >
                    <path
                        d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 
              1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"
                    />
                    <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                </svg>
            </div>
            <div class="margin">
                <div class="subtitle">
                    Aplicação disponível apenas para dispositivos móveis utilizando Chrome
                    ou Safari.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//const ErrorBoundary = {
//    data: () => ({ error: null }),
//    errorCaptured (err, vm, info) {
//        this.error = `${err.stack}\n\nfound in ${info} of component`;
//        return false;
//    },
//    render (h) {
//        if (this.error) {
//            return h("pre", { style: { color: "red" }}, this.error);
//        }
//        // ignoring edge cases for the sake of demonstration
//        return this.$slots.default[0];
//    }
//};

export default {
    name: "App",
    //components: {
    //    "error-boundary": ErrorBoundary
    //},
    data: function () {
        return {
            isMobile: false,
            isChromeOrSafari: false,
        };
    },
    methods: {
        _isMobile() {
            let isMobile = /iphone|ipod|ipad|android|ie|blackberry|fennec/.test(
                navigator.userAgent.toLowerCase()
            );
            console.log(navigator.userAgent.toLowerCase());
            return isMobile;
        },
        _isChromeOrSafari() {
            let userAgent = navigator.userAgent.toLowerCase();
            let isChrome = userAgent.indexOf("chrome") != -1;
            let isSafari = userAgent.indexOf("safari") != -1;
            if (isChrome || isSafari) return true;
        },
    },
    mounted: function () {
        let useHttps = import.meta.env.VITE_USE_HTTPS == "true";
        if (useHttps) {
            if (location.protocol !== "https:") {
                location.replace(
                    `https:${location.href.substring(location.protocol.length)}`
                );
            }
        }

        this.isMobile = this._isMobile();
        this.isChromeOrSafari = this._isChromeOrSafari();
    },
};
</script>

<style scoped>

#app {
    height: 100%;
    font-family: "Roboto";
    font-style: normal;
    color: black;
}
.mobile {
    height: 100%;
}
.marginLogo {
    margin-top: 3vh;
    text-align: center;
}
.margin {
    margin-top: 10vh;
    text-align: center;
}
.marginTitle {
    margin-top: 5vh;
}
.title {
    font-family: "Roboto";
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    line-height: 33px;
    color: black;
    margin-left: 10px;
    margin-right: 10px;
}
.subtitle {
    font-family: "Roboto";
    font-size: 20px;
    text-align: center;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.8);
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 4vh;
    margin-bottom: 2vh;
}
</style>
